import { FirstParameter, SecondParameter } from "@/openapi/types";
import axiosInstance from "@/openapi/axiosInstance";
import {
  changeSupplyContractInfoPc,
  postBaobPcSupplyGetMessagePopup,
  postBaobPcSupplyMakePrintSign,
} from "@/openapi/baob/pc.Supply/api.client.axios";
import {
  MutateFunction,
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";

/**
 * 修改合同签署信息（姓名、身份证号、身份证正反面照片）。is_check=1 仅校验不落库，is_check=0 提交更新。
 */
export const useChangeSupplyContractInfoPc = (options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeSupplyContractInfoPc>>,
    Error,
    FirstParameter<typeof changeSupplyContractInfoPc>
  >;
  request?: SecondParameter<typeof changeSupplyContractInfoPc>;
}) => {
  const mutationFn: MutateFunction<
    Awaited<ReturnType<typeof changeSupplyContractInfoPc>>,
    Error,
    FirstParameter<typeof changeSupplyContractInfoPc>
  > = (variables) => {
    return changeSupplyContractInfoPc(variables, options?.request);
  };
  return useMutation({ mutationFn, ...options?.mutation });
};

export const usePostBaobPcSupplyGetMessagePopup = (options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBaobPcSupplyGetMessagePopup>>,
    Error,
    FirstParameter<typeof postBaobPcSupplyGetMessagePopup>
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const mutationFn: MutateFunction<
    Awaited<ReturnType<typeof postBaobPcSupplyGetMessagePopup>>,
    Error,
    FirstParameter<typeof postBaobPcSupplyGetMessagePopup>
  > = (variables) => {
    return postBaobPcSupplyGetMessagePopup(variables, options?.request);
  };
  return useMutation({ mutationFn, ...options?.mutation });
};

export const useQueryPostBaobPcSupplyGetMessagePopup = (options: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof postBaobPcSupplyGetMessagePopup>>,
      Error,
      Awaited<ReturnType<typeof postBaobPcSupplyGetMessagePopup>>
    >
  >;
  params: FirstParameter<typeof postBaobPcSupplyGetMessagePopup>;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  return useQuery({
    queryKey: [`/baob/pc.Supply/getMessagePopup`, options.params],
    queryFn: () =>
      postBaobPcSupplyGetMessagePopup(options.params, options?.request),
    ...options?.query,
  });
};

export const usePostBaobPcSupplyMakePrintSign = (options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBaobPcSupplyMakePrintSign>>,
    Error,
    FirstParameter<typeof postBaobPcSupplyMakePrintSign>
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const mutationFn: MutateFunction<
    Awaited<ReturnType<typeof postBaobPcSupplyMakePrintSign>>,
    Error,
    FirstParameter<typeof postBaobPcSupplyMakePrintSign>
  > = (variables) => {
    return postBaobPcSupplyMakePrintSign(variables, options?.request);
  };
  return useMutation({ mutationFn, ...options?.mutation });
};
